import React from "react"

import appStore from "../assets/images/app-store.png"
import playStore from "../assets/images/play-store.png"
import { Card, Image } from "react-bootstrap"
import { appConfigs } from "../configs/config"
import { downLoadVisit } from "../analytics"
import { FaAndroid, FaApple, FaAppStoreIos, FaGooglePlay } from "react-icons/fa"
import { BsAndroid } from "react-icons/bs"
import { ImAndroid } from "react-icons/im"

export const DownloadAppFooter = ({
  title,
  subtitle = "Unlock Events, Finances, Voting & More",
}) => {
  return (
    <div>
      <div style={{ height: "5rem" }} />
      <div
        className="bg-primary text-white py-2"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        <div className="container d-flex justify-content-between align-items-center">
          <div>
            <p
              className="fw-bold mb-0"
              style={{
                fontSize: "0.9rem",
              }}
            >
              {title || `Download the ${appConfigs.appName} App`}
            </p>
            <p
              className="mb-0 mt-1 fw-light"
              style={{
                fontSize: "0.6rem",
              }}
            >
              {subtitle}
            </p>
          </div>
          <div className="d-flex justify-content-end ms-1 gap-2">
            <ImAndroid
              size={30}
              className="cursor-pointer"
              style={{ cursor: "pointer" }}
              onClick={() =>
                downLoadVisit("android", `${appConfigs.appName} Web`)
              }
            />
            <FaApple
              size={30}
              className="cursor-pointer"
              style={{ cursor: "pointer" }}
              onClick={() => downLoadVisit("ios", `${appConfigs.appName} Web`)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

function DownloadAppComponent({
  subtitle = "Unlock Events, Finances, Voting & More",
  title,
}) {
  return (
    <Card
      bg={"primary"}
      className={"text-white"}
    >
      <Card.Body>
        <h3 className={"fw-bolder"}>
          {title || `Download the ${appConfigs.appName} App`}
        </h3>
        <p className={"mb-4 fw-bold"}>{subtitle}</p>
        <div>
          <p>
            <Image
              className={"pointer"}
              fluid={false}
              src={playStore}
              height={"auto"}
              width={"130px"}
              onClick={() =>
                downLoadVisit("android", `${appConfigs.appName} Web`)
              }
            />
            <span className={"ms-1"}></span>
            <Image
              className={"pointer"}
              fluid={false}
              src={appStore}
              height={"auto"}
              width={"130px"}
              onClick={() => downLoadVisit("ios", `${appConfigs.appName} Web`)}
            />
          </p>
        </div>
      </Card.Body>
    </Card>
  )
}

export default DownloadAppComponent
